import { getExplorerLink } from 'modules/common/utils/getExplorerLink';
import { OChainId, TChainId } from './chainIDs';
import { BTC_DECIMALS } from 'modules/common/const';
import { getEvmConfig } from './web3SDK/evmConfig';

export const VAULT_CONTRACT = '0x309f25d839A2fe225E80210e110C99150Db98AAF';

const LBTCV_TELLER_CONTRACT_ETHEREUM =
  '0x258f532CB41393c505554228e66eaf580B0171b2';

const LBTCV_TELLER_CONTRACT_SONIC = LBTCV_TELLER_CONTRACT_ETHEREUM;

const getTellerContract = (chainId: TChainId) => {
  if (chainId === OChainId.ethereum) {
    return LBTCV_TELLER_CONTRACT_ETHEREUM;
  }

  if (chainId === OChainId.sonic) {
    return LBTCV_TELLER_CONTRACT_SONIC;
  }

  console.error(`Unsupported chainId: ${chainId}`);

  return '';
};

const getWithdrawQueueContract = () => {
  return '0xAea73B51380Fa5C0f76F0611c4346af4090ED2D7';
};

const getAccountantContract = () => {
  return '0x0639e239E417Ab9D1f0f926Fd738a012153930A7';
};

export const vaultConfiguration = {
  getTellerContract,
  getWithdrawQueueContract,
  lensContract: '0x5232bc0F5999f8dA604c42E1748A13a170F94A1B',
  vaultContract: VAULT_CONTRACT,
  getAccountantContract,
  getBaseAsset: (chainId: TChainId) => ({
    displayName: 'LBTC',
    address: getEvmConfig('prod')[chainId]?.LBTC || '',
    decimals: BTC_DECIMALS,
  }),
  boringQueueContract: getWithdrawQueueContract(),
  getExplorerLink: (chainId: TChainId) =>
    getExplorerLink(VAULT_CONTRACT, chainId, 'address'),
} as const;

export const OVaultNetwork = {
  ethereum: 'ethereum',
  sonic: 'sonic',
} as const;

export type IVaultNetwork = (typeof OVaultNetwork)[keyof typeof OVaultNetwork];

export const chainIdToVaultNetwork = (
  chainId?: TChainId | number,
): IVaultNetwork => {
  if (chainId === OChainId.sonic) {
    return OVaultNetwork.sonic;
  }

  return OVaultNetwork.ethereum;
};
